import React from 'react';
import PropTypes from 'prop-types';

const AdjustmentControlsColumn = ({ role, scope, children }) => (
  <th
    data-testid="adjustment-controls-column"
    role={role}
    scope={scope}
    className="adjustment-controls-column"
  >
    {children}
  </th>
);

AdjustmentControlsColumn.propTypes = {
  role: PropTypes.oneOf(['columnheader', 'rowheader']),
  scope: PropTypes.oneOf(['col', 'row']),
  children: PropTypes.node,
};

AdjustmentControlsColumn.defaultProps = {
  role: 'rowheader',
  scope: 'row',
  children: undefined,
};

export default AdjustmentControlsColumn;
